<template>
  <v-tabs
    v-model="activeTab"
    fixed-tabs
    background-color="rgb(192, 215, 228)"
    color="#1d3557"
    max-width="none"
    width="25px"
  >
    <!-- <v-tab> 1 Person 1 Vote </v-tab> -->
    <v-tab> Population equality? </v-tab>
    <v-tab> Demographics </v-tab>
  </v-tabs>
</template>
<script>
import {Enums} from "../../../data/Config/Config";
export default {
  name: "SideMenuTabs",
  components: {
      
  },
  data: function () {
    return {
        Enums:Enums,
    };
  },
  mounted: function () {},
  watch:{},
  computed: {
    activeTab: {
      get: function () {
        return this.$store.getters.getSideTab;
      },
      set: function (val) {
        this.$store.commit("setSideTab", val);
      },
    },
  },
};
</script>
<style></style>